// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87c3acfc","761":"455fa841"}[chunkId] + ".chunk.js";
};